import { defer, distinctUntilChanged, from, Observable } from 'rxjs';
import { Actor, AnyActorLogic, SnapshotFrom } from 'xstate';

export function fromActor<TLogic extends AnyActorLogic>(actor: Actor<TLogic>): Observable<SnapshotFrom<TLogic>> {
  return defer(() => {
    return from(actor).pipe(distinctUntilChanged());
  });
}
